import axios from "axios";

import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

const verifyOtp = async (email, otp) => {
    const response = await axios.post(routes.verifyOtp, {
        email, otp
    }, AXIOS_DEFAULT_CONFIG);

    const token = response.data?.token;
    if (token) {
        localStorage.setItem("authToken", token);
    }

    return response;
}

export default verifyOtp;
